module.exports = __webpack_public_path__ + "static/media/pre-order-details-banner-wb.ecbb691c.png";